import { render, staticRenderFns } from "./SimpleStatsView.vue?vue&type=template&id=1854b0c8&"
import script from "./SimpleStatsView.vue?vue&type=script&lang=js&"
export * from "./SimpleStatsView.vue?vue&type=script&lang=js&"
import style0 from "./SimpleStatsView.vue?vue&type=style&index=0&id=1854b0c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports